<template>
  <div>
    <h5 class="info-text">Selecciona el albarán</h5>
    <div class="md-layout">
      <div
        class="md-layout-item md-size-95 ml-auto mt-4 md-small-size-100 md-alignment-center-center"
      >
        <h5 v-if="issue.albaranes.length == 0">No se han encontrado albaranes para este cliente.</h5>
        <md-table
          v-model="issue.albaranes"
          @md-selected="onSelect"
          v-if="issue.albaranes.length > 0"
        >
          <md-table-row
            slot="md-table-row"
            slot-scope="{ item }"
            md-selectable="multiple"
            md-auto-select
          >
            <md-table-cell md-label="Número">{{ item.numero }}</md-table-cell>
            <md-table-cell md-label="Fecha">{{ item.fecha | moment("DD/MM/YYYY") }}</md-table-cell>
          </md-table-row>
        </md-table>
      </div>
    </div>
  </div>
</template>
<script>
import { IconCheckbox, Badge } from "@/components";
import { apiServer, staticServer, florette_web } from "@/globalVars.js";

export default {
  name: "seleccion-pedido-step",
  components: {
    IconCheckbox,
    Badge
  },
  props: {
    issue: {
      type: Object
    }
  },
  data() {
    return {
      radio: null,
      selected: [],
      model: {
        design: false,
        code: true,
        develop: false
      }
    };
  },
  methods: {
    validate() {
      return this.$validator.validateAll().then(res => {
        res = res && this.issue.selectedAlbaranes.length > 0;
        this.$emit("on-validated", res);
        return res;
      });
    },
    getDateString(value) {
      let d = new Date(value);
      return d.toLocaleString("es-ES", { timeZone: "Europe/Madrid" });
    },
    onSelect(items) {
      this.issue.productos = [];
      this.issue.selectedAlbaranes = items;
      for (let index = 0; index < items.length; index++) {
        const element = items[index];
        for (
          let index_product = 0;
          index_product < element.lineas.length;
          index_product++
        ) {
          const product = element.lineas[index_product];
          product.codigoAlbaran = element["numero"];
          product.albaranId = element["_id"];
          product.selected = false;
          this.issue.productos.push(product);
        }
      }
    }
  }
};
</script>
<style>
</style>
